import Vue from 'vue';
import { recognition } from 'mycorems-app-accounts';

export default Vue.extend({
  props: {
    customerId: {
      type: String,
      default() {
        return recognition.getAccountId();
      },
    },
  },
});
